module.exports = __webpack_public_path__ + "static/media/donate.8219712d.png";